module.exports = __webpack_public_path__ + "img/price.0e640a41.png";